import { SET_PARISH_AND_COLLECTION } from "@/store/mutation-types"

export default {
  [SET_PARISH_AND_COLLECTION] (state, { parishId, collectionIndex }) {
    state.parishId = parishId
    state.collectionIndex = collectionIndex
  },
}
